import { Component, OnInit } from '@angular/core';
import { DraftService } from 'app/modules/draft/services/draft.service';
import { DraftComponent } from 'app/modules/draft/components/draft/draft.component';
import { environment } from 'environments/environment';
import { SearchGamePipe } from 'shared/pipes/searchGame/searchGame.pipe';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-draft-result',
  templateUrl: './draft-result.component.html',
  styleUrls: ['./draft-result.component.css'],
})
export class DraftResultComponent implements OnInit {

  _YOUR_GAMES;
  _YOUR_GAMES_COPY;
  imgURLHandle = environment.URL_TEAM_IMAGES;
  _TEAM;
  owner;

  constructor(
    private draftService: DraftService,
    private searchGamePipe: SearchGamePipe,
    private userService: UserService,
    private draftComponent: DraftComponent) {
    /* this.draftComponent.searchQueuedGames.subscribe(data => {
      this._YOUR_GAMES = this.searchGamePipe.transform(this._YOUR_GAMES_COPY, data);
    }); */

    this.draftService.yourResultsSubscription$.subscribe(results => {
      this._TEAM = this.draftService.getTeamName();
      this._YOUR_GAMES = results;
      this._YOUR_GAMES_COPY = results;
    });
    this.owner = this.userService.user.firstName + ' ' + this.userService.user.lastName;

  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/draft/components/draft-result/draft-result.component.ts